import { NgModule } from '@angular/core';
import { translationChunksConfig } from '@spartacus/assets';
import { defaultB2BCheckoutConfig } from '@spartacus/checkout/b2b/root';
import {
  FeaturesConfig,
  I18nConfig,
  OccConfig,
  SiteContextConfig,
  provideConfig
} from '@spartacus/core';
import { defaultB2bOccConfig } from '@spartacus/setup';
import { SmartEditConfig } from '@spartacus/smartedit/root';
import { LayoutConfig, ViewConfig, defaultCmsContentProviders, layoutConfig, mediaConfig } from '@spartacus/storefront';
import { environment } from '../../environments/environment';
import { uigAuthConfig } from '../config/uig-auth.config';

@NgModule({
  declarations: [],
  imports: [
  ],
  providers: [provideConfig(layoutConfig), provideConfig(mediaConfig), ...defaultCmsContentProviders, provideConfig(uigAuthConfig), provideConfig({
    backend: {
      occ: {
        ...environment.occ,
      }
    },
  } as OccConfig), provideConfig({
    context: {
      urlParameters: ['baseSite', 'language', 'currency'],
      baseSite: ['rfde', 'rfat', 'rfnl'],
      currency: ['EUR'],
      language: ['de', 'en', 'nl'],
    },
  } as SiteContextConfig), provideConfig({
    smartEdit: {
      storefrontPreviewRoute: 'cx-preview',
      allowOrigin: 'localhost:9002, *.*.model-t.cc.commerce.ondemand.com:443',
    },
  } as SmartEditConfig), provideConfig({
    features: {
      level: '*'
    }
  } as FeaturesConfig), provideConfig({
    view: {
      infiniteScroll: {
        active: true,
        productLimit: 500,
        showMoreButton: false,
      },
    }
  } as ViewConfig), provideConfig(defaultB2bOccConfig),
  provideConfig({
    layoutSlots: {
      LandingPage2Template: {
        slots: [
          'SectionU0',
          'SectionU1A',
          'SectionU1B',
          'SectionU1C',
          'SectionU1D',
          'SectionU1',
          'SectionU2A',
          'SectionU2B',
          'SectionU2C',
          'SectionU2D',
          'SectionU2',
          'SectionU3A',
          'SectionU3B',
          'SectionU3C',
          'SectionU3D',
          'SectionU3',
          'SectionU4A',
          'SectionU4B',
          'SectionU4C',
          'SectionU4D',
          'SectionU4',
          'SectionU5A',
          'SectionU5B',
          'SectionU5C',
          'SectionU5D',
          'SectionU5',
          'SectionU6A',
          'SectionU6B',
          'SectionU6C',
          'SectionU6D',
          'SectionU6',
          'SectionU7A',
          'SectionU7B',
          'SectionU7C',
          'SectionU7D',
          'SectionU7',
          'SectionU8A',
          'SectionU8B',
          'SectionU8C',
          'SectionU8D',
          'SectionU8',
          'SectionU9A',
          'SectionU9B',
          'SectionU9C',
          'SectionU9D',
          'SectionU9',
          'SectionU10A',
          'SectionU10B',
          'SectionU10C',
          'SectionU10D',
          'SectionU10',
          'SectionU11A',
          'SectionU11B',
          'SectionU11C',
          'SectionU11D',
          'SectionU11',
          'SectionU12A',
          'SectionU12B',
          'SectionU12C',
          'SectionU12D',
          'SectionU12'
        ]
      },
    },
  } as LayoutConfig), provideConfig({
    i18n: {
      backend: {
        loadPath: 'assets/i18n-assets/{{lng}}/{{ns}}.json'
        // crossOrigin: true (use this option when i18n assets come from a different domain)
      },
      chunks: translationChunksConfig,
      fallbackLang: 'en'
    },
  } as I18nConfig), provideConfig(defaultB2BCheckoutConfig)]
})
export class SpartacusConfigurationModule { }
